import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-950 text-white p-8">
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-light mb-4" style={{fontFamily:"'Cormorant Garamond',serif"}}>
              Κάτι πήγε στραβά.
            </h2>
            <p className="text-gray-400 text-sm mb-8">{this.state.error?.message}</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 border border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-black transition-all text-xs uppercase tracking-widest"
            >
              Ανανέωση Σελίδας
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}